import React from "react"
import { Col, Row, Space, Table, Tooltip, Typography } from "antd"
import { ASAPOrder, OrderAndPrefix } from "../../../Orders/Helpers/OrderAndPrefix"
import "../../../../styles/OrderTable.css"

const { Text } = Typography

export default function UpcomingDesignerOrders({ orders = [], ordersLoading = false }) {
  // Simple helper to turn every column on/off for ellipsis
  const ellipsisColumns = {
    orderNumber: true,
    client: true,
    product: true,
    manager: true,
    quantity: true,
    materialWidth: true,
    material: true,
  }

  // Build filter lists from the orders array:
  const clientFilters = orders.reduce((acc, item) => {
    const clientName = item.client?.client
    if (clientName && !acc.find((f) => f.value === clientName)) {
      acc.push({ text: clientName, value: clientName })
    }
    return acc
  }, [])

  const productFilters = orders.reduce((acc, item) => {
    const productName = item.selectedProduct?.product?.productName
    if (productName && !acc.find((f) => f.value === productName)) {
      acc.push({ text: productName, value: productName })
    }
    return acc
  }, [])

  const materialFilters = orders.reduce((acc, item) => {
    const materialName = item.selectedProduct?.material
    if (materialName && !acc.find((f) => f.value === materialName)) {
      acc.push({ text: materialName, value: materialName })
    }
    return acc
  }, [])

  const userFilters = orders.reduce((acc, item) => {
    const userName = item.user
    if (userName && !acc.find((f) => f.value === userName)) {
      acc.push({ text: userName, value: userName })
    }
    return acc
  }, [])

  // Define your table columns
  const tableColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      key: "orderNumber",
      width: "15%",
      ellipsis: ellipsisColumns.orderNumber,
      align: "center",
      sorter: (a, b) => a.justOrderNumber - b.justOrderNumber,
      render: (_, record) => (
        <Space>
          {ASAPOrder(record)}
          {OrderAndPrefix(record)}
        </Space>
      ),
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      key: "client",
      align: "center",
      ellipsis: ellipsisColumns.client,
      filters: clientFilters,
      onFilter: (value, record) => record.client.client === value,
      filterSearch: true,
      sorter: (a, b) => (a.client?.client || "").localeCompare(b.client?.client || ""),
      render: (text) => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      key: "product",
      align: "center",
      ellipsis: ellipsisColumns.product,
      filters: productFilters,
      onFilter: (value, record) => record.selectedProduct.product.productName === value,
      filterSearch: true,
      render: (text) => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    {
      title: "Manager",
      dataIndex: "user",
      key: "manager",
      align: "center",
      ellipsis: ellipsisColumns.manager,
      filters: userFilters,
      onFilter: (value, record) => record.user === value,
    },
    {
      title: "Quantity",
      dataIndex: "labelCount",
      key: "quantity",
      align: "center",
      ellipsis: ellipsisColumns.quantity,
      sorter: (a, b) => a.labelCount - b.labelCount,
    },
    {
      title: "M.Width",
      dataIndex: ["selectedProduct", "formatWidth"],
      key: "materialWidth",
      align: "center",
      ellipsis: ellipsisColumns.materialWidth,
      sorter: (a, b) => a.selectedProduct.formatWidth - b.selectedProduct.formatWidth,
      render: (value) => <Text>{value} mm</Text>,
    },
    {
      title: "Material",
      dataIndex: ["selectedProduct", "material"],
      key: "material",
      align: "center",
      ellipsis: ellipsisColumns.material,
      filters: materialFilters,
      onFilter: (value, record) => record.selectedProduct.material === value,
      filterSearch: true,
      render: (text) => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Table
            rowKey="id"
            loading={ordersLoading}
            dataSource={orders}
            columns={tableColumns}
            size="small"
            bordered
            pagination={{ pageSize: 25, showSizeChanger: true, size: "small" }}
            rowClassName={(record) => (record.priorityOrder ? "red-background" : "")}
          />
        </Col>
      </Row>
    </div>
  )
}
